function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, Fragment } from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../common/helpers.js";
import { Button } from "../Button/index.js";
import { Container as Root } from "../Container/index.js";
const classes = cva([
    'flex',
    'flex-col',
    'md:flex-row',
    'gap-5',
    'w-full'
], {
    variants: {
        alignment: {
            'left': [
                'justify-start'
            ],
            'center': [
                'justify-center'
            ],
            'right': [
                'justify-end'
            ]
        }
    }
});
/**
 * Button Block - [API](https://scl.sharp.com/?path=/docs/components-buttonblock) | [DSM](https://sharphealthcare.notion.site/Button-block-fe3421084a964e9a80b2bd9061a651aa)
 *
 * @example
 *
 * <ButtonBlock
 *  buttonPrimary={{label: 'Primary'}}
 *  buttonSecondary={{label: 'Secondary'}}
 *  alignment="center" />
 *
 */ const ButtonBlock = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { buttonPrimary, buttonSecondary, alignment = 'left', className, slots = {}, slotProps = {}, as = 'div' } = _param, rest = _object_without_properties(_param, [
        "buttonPrimary",
        "buttonSecondary",
        "alignment",
        "className",
        "slots",
        "slotProps",
        "as"
    ]);
    var _slots_buttonPrimaryContainer;
    const ButtonPrimaryContainer = (_slots_buttonPrimaryContainer = slots.buttonPrimaryContainer) !== null && _slots_buttonPrimaryContainer !== void 0 ? _slots_buttonPrimaryContainer : slotProps.buttonPrimaryContainer ? 'div' : Fragment;
    var _slots_buttonPrimary;
    const ButtonPrimary = (_slots_buttonPrimary = slots.buttonPrimary) !== null && _slots_buttonPrimary !== void 0 ? _slots_buttonPrimary : Button;
    const buttonPrimaryProps = slots.buttonPrimary ? slotProps.buttonPrimary : _object_spread({
        variant: 'filled'
    }, buttonPrimary, slotProps.buttonPrimary);
    var _slots_buttonSecondaryContainer;
    const ButtonSecondaryContainer = (_slots_buttonSecondaryContainer = slots.buttonSecondaryContainer) !== null && _slots_buttonSecondaryContainer !== void 0 ? _slots_buttonSecondaryContainer : slotProps.buttonSecondaryContainer ? 'div' : Fragment;
    var _slots_buttonSecondary;
    const ButtonSecondary = (_slots_buttonSecondary = slots.buttonSecondary) !== null && _slots_buttonSecondary !== void 0 ? _slots_buttonSecondary : Button;
    const buttonSecondaryProps = slots.buttonSecondary ? slotProps.buttonSecondary : _object_spread({
        variant: 'outlined'
    }, buttonSecondary, slotProps.buttonSecondary);
    return /*#__PURE__*/ _jsxs(Root, _object_spread_props(_object_spread({}, rest), {
        ref: ref,
        as: as,
        className: cn(classes({
            alignment,
            className
        })),
        children: [
            /*#__PURE__*/ _jsx(ButtonPrimaryContainer, _object_spread_props(_object_spread({}, slotProps.buttonPrimaryContainer), {
                children: /*#__PURE__*/ _jsx(ButtonPrimary, _object_spread({}, buttonPrimaryProps))
            })),
            (buttonSecondary || slots.buttonSecondary) && /*#__PURE__*/ _jsx(ButtonSecondaryContainer, _object_spread_props(_object_spread({}, slotProps.buttonSecondaryContainer), {
                children: /*#__PURE__*/ _jsx(ButtonSecondary, _object_spread({}, buttonSecondaryProps))
            }))
        ]
    }));
});
export { ButtonBlock };
